/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseCourseidChannels200,
  GetApiV1CourseCourseidChannels400,
  GetApiV1CourseCourseidChannels401,
  GetApiV1CourseCourseidChannels404,
  GetApiV1CourseCourseidChannels500,
  GetApiV1CourseCourseidChannelsPathParams,
  GetApiV1CourseCourseidChannelsQueryParams,
  GetApiV1CourseCourseidChannelsQueryResponse,
} from "../../types/courseChannelsController/GetApiV1CourseCourseidChannels.ts";
import { channelListItemViewModelPaginatedResponseSchema } from "../channelListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1CourseCourseidChannelsPathParamsSchema = z.object({
  courseId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CourseCourseidChannelsPathParams>;

export const getApiV1CourseCourseidChannelsQueryParamsSchema = z.object({
  Search: z.optional(
    z
      .string()
      .describe(
        "Texto livre aplicado ao nome do canal e ao ID do vídeo no Vimeo. Opcional.",
      ),
  ),
  Active: z
    .boolean()
    .default(true)
    .describe(
      "Filtra por situação do canal. Vem ligado por padrão, reproduzindo o filtro que no legado existia apenas no grid. Informe nulo para trazer ativos e inativos.",
    ),
  PageNumber: z.coerce
    .number()
    .int()
    .default(1)
    .describe("Página da listagem. Mínimo 1."),
  PageSize: z.coerce
    .number()
    .int()
    .default(30)
    .describe("Quantidade de itens por página. Entre 1 e 100."),
}) as unknown as ToZod<GetApiV1CourseCourseidChannelsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseCourseidChannels200Schema = z.lazy(
  () => channelListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1CourseCourseidChannels200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseCourseidChannels400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidChannels400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseCourseidChannels401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidChannels401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseCourseidChannels404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidChannels404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseCourseidChannels500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidChannels500>;

export const getApiV1CourseCourseidChannelsQueryResponseSchema = z.lazy(
  () => getApiV1CourseCourseidChannels200Schema,
) as unknown as ToZod<GetApiV1CourseCourseidChannelsQueryResponse>;
